import React from 'react';
import { getRem } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledChipShortcutContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1 1 100%;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.size.spacing.large.value};
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.datepickerShortcuts.value};
  ${({ $isRight, theme }) =>
    $isRight &&
    css`
      flex-direction: column;
      padding-right: ${getRem('24px')};
      padding-top: ${theme.size.spacing.medium.value};
      width: ${getRem('140px')};
    `}
  ${({ $isBottom }) =>
    $isBottom &&
    css`
      margin-top: -${getRem('36px')};
      justify-content: center;
    `}
`;

const ChipShortcutContainer = ({ isBottom = false, isRight = false, ...other }) => (
  <StyledChipShortcutContainer $isBottom={isBottom} $isRight={isRight} {...other} />
);

ChipShortcutContainer.propTypes = {
  /** If true, will render container at the bottom */
  isBottom: PropTypes.bool,
  /** If true, will render container on the right */
  isRight: PropTypes.bool,
};

export { ChipShortcutContainer };
